function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var LocationIcon = function LocationIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "18",
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "7.93338",
    cy: "7.46616",
    r: "2.23667",
    stroke: "#626B77",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.65 7.57183C14.65 10.1969 12.9661 12.5993 11.1382 14.4143C10.2385 15.3077 9.33596 16.0268 8.65741 16.5228C8.36813 16.7343 8.12079 16.9043 7.93334 17.0291C7.74589 16.9043 7.49855 16.7343 7.20927 16.5228C6.53072 16.0268 5.62818 15.3077 4.72846 14.4143C2.90059 12.5993 1.21667 10.1969 1.21667 7.57183C1.21668 3.79431 4.23369 0.75 7.93334 0.75C11.633 0.75 14.65 3.79431 14.65 7.57183Z",
    stroke: "#626B77",
    strokeWidth: "1.5"
  }));
};

export default LocationIcon;